import { render, staticRenderFns } from "./translationLog.vue?vue&type=template&id=f44d5f72&scoped=true&"
import script from "./translationLog.vue?vue&type=script&lang=js&"
export * from "./translationLog.vue?vue&type=script&lang=js&"
import style0 from "./translationLog.vue?vue&type=style&index=0&id=f44d5f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44d5f72",
  null
  
)

export default component.exports